import { PortableText } from '@portabletext/react';
import { Link } from 'gatsby';
import React from 'react';
import * as classes from './PortableContentWithLinks.module.scss';

const LinksComponent = ({ links, color = 'blue' }) => {
  const linkColors = {
    blue: 'primary',
    green: 'ocean-green',
    purple: 'tertiary',
  };
  return (
    <div className={classes.linkWrapper}>
      {links.map((link) => (
        <Link key={link._key} to={link.url} className={`btn-link-${linkColors[color]} text-uppercase mt-3`}>
          {link.title}
        </Link>
      ))}
    </div>
  );
};

const getPortableContentWithLinks = (linkColor) => ({
  types: {
    links: ({ value: { links } }) => <LinksComponent links={links} color={linkColor} />,
  },
});

export const PortableContentWithLinks = ({ value, linkColor }) => (
  <PortableText value={value} components={getPortableContentWithLinks(linkColor)} />
);
